// [목적] 폴리오 Fork mutation hook — POST /folios/:id/fork 호출 후 새 folio 반환
// [이유] WC-FE-FOLIO-05 — FolioPage 의 Fork CTA 버튼에서 호출. 성공 시 navigate('/folio/:newId')
// [사이드 이팩트] fork 성공 후 folioList 캐시 invalidate (목록에 새 folio 반영)
// [수정 시 고려사항] guest 리디렉션은 컴포넌트(FolioPage)에서 useAuth().requireAuth() 로 처리 — 본 훅은 인증 확인 미포함

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Folio, ForkFolioInput } from '@gangwoncanvas/types';

import { forkFolio } from '../api/folioClient.js';

interface ForkArgs {
  folioId: string;
  input?: ForkFolioInput;
}

/**
 * [목적] 폴리오 Fork useMutation — onSuccess 에서 folioList 캐시 invalidate
 * [이유] WC-FE-FOLIO-05 — Fork 성공 후 호출처에서 result.data.id 로 /folio/:id navigate
 * [사이드 이팩트] ['folio-list'] 키 invalidate — 목록 화면 자동 갱신
 * [수정 시 고려사항] day_import fork 는 kind='day_import'+sourceDayIndex+targetPortfolioId 필요 — 후속 Spec
 */
export function useForkFolio() {
  const qc = useQueryClient();

  return useMutation<Folio, Error, ForkArgs>({
    mutationFn: ({ folioId, input }) => forkFolio(folioId, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['folio-list'] });
    },
  });
}
